import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { Nullable } from 'clickNgo/models/utils'
import { fetchGlobalPartnerById } from 'clickNgo/services/globalPartner'
import { IFetchQbrDocumentResponse } from 'partner360/models/qbr/IFetchQbrDocumentResponse'

import { fetchQbrDocument } from '../../../services/qbr/fetchQbrDocument'
import { REQUEST_QBR_DOCUMENT } from '../constants'

interface IRequestQbrDocument {
  documentId: number
  isForceUpdate?: boolean
}

interface IRequestQbrDocumentRes {
  document: Nullable<IFetchQbrDocumentResponse>
  documentPartnerName: string | null
}

export const requestQbrDocument = createAsyncThunk<IRequestQbrDocumentRes, IRequestQbrDocument>(
  REQUEST_QBR_DOCUMENT,
  async (params) => {
    const document = await fetchQbrDocument({
      documentId: params.documentId,
      isForceUpdate: params.isForceUpdate,
    })

    const documentPartnerName =
      document?.GlobalPartnerId && document?.GlobalPartnerId?.startsWith('GP')
        ? (await fetchGlobalPartnerById(document?.GlobalPartnerId)).globalPartnerName
        : null

    return { document, documentPartnerName }
  }
)
